import React from 'react';
import { formatMoney } from '../../../../utils/utils';
import { momentParseDate } from '../../../../helpers';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { FundsFilters } from '../../../../app/models/Fund';
import { CheckingAccountFilters } from '../../../../app/models/CheckingAccount';

type Props = {
    data: any[];
    progressPending?: boolean;
    filter: CheckingAccountFilters;
    setFilter: (filter: CheckingAccountFilters) => void;
    totalRows: number
};

const WorkerFundsDataTable = ({ 
    data, 
    progressPending, 
    filter,
    setFilter,
    totalRows
}: Props) => {
    const columns = [
        {
            name: 'Solicitud de fondos',
            selector: (row: any) => row.id,
            sortable: false,
            sortField: 'motivo',
            cell: (row: any, index: any, column: any) => (
                <span className="">#{row.id}</span>
            )
        },
        {
            name: 'Monto',
            selector: (row: any) => row.bank,
            sortable: false,
            sortField: 'banco',
            cell: (row: any, index: any, column: any) => (
                <span className="">{formatMoney(row.amount)}</span>
            )
        },
        {
            name: 'Conductor',
            selector: (row: any) => row?.carrier,
            sortable: true,
            sortField: 'carrier',
            cell: (row: any, index: any, column: any) => (
                <span className="">
                    <div dangerouslySetInnerHTML={{ __html: row.carrier ? row.carrier : '' }} />
                </span>
            )
        },
        {
            name: 'Motivo',
            selector: (row: any) => row.transfer_reason,
            sortable: false,
            sortField: 'banco',
            cell: (row: any, index: any, column: any) => (
                <span className="">{row.transfer_reason}</span>
            )
        },
        {
            name: 'Fecha de Emisión',
            selector: (row: any) => row?.issue_date,
            sortable: false,
            sortField: 'program_date',
            minWidth: '120px',
            cell: (row: any, index: any, column: any) => (
                <span className="">
                    {momentParseDate(row.issue_date)}
                </span>
            )
        },

    ]
    return (
        <div>
            <DefaultDataTable
                columns={columns}
                data={data}
                progressPending={progressPending}
                paginationTotalRows={totalRows} 
                filter={filter} 
                setFilter={setFilter}   
                isMobileStacked={true}       
            />
        </div>
    )
}

export default WorkerFundsDataTable
